/**
 * Le message d'un refus, que le serveur reponde une phrase ou un objet.
 *
 * ⚠️ `detail` N'EST PAS TOUJOURS UNE CHAINE. Le refus d'une reference de chantier
 * ambigue porte un objet — `{ code, message, reference_chantier, chantiers }` — parce
 * qu'il PROPOSE les chantiers au lieu de renvoyer l'utilisateur a sa saisie. Afficher
 * `detail` tel quel ecrirait « [object Object] » a la place du refus.
 *
 * Sorti de la page le 26/10 (lot L1) : quatre composants de la fiche s'en servent.
 */
export const messageDeRefus = (erreur, secours) => {
  const detail = erreur?.response?.data?.detail;
  if (detail && typeof detail === 'object') return detail.message || secours;
  return detail || secours;
};

/** Le refus porte-t-il une liste de chantiers a proposer ? */
export const chantiersProposes = (refus) =>
  (refus && typeof refus === 'object' && Array.isArray(refus.chantiers))
    ? refus.chantiers : null;
